import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";

import "../../styles/header.css";
import { useAuth } from "../../services/authentication/authentication.context";
import { formatUrl } from "../../_helpers/parseurl";
import { AppAlert } from "../utilities/app-alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";



const headerRoutes = [
    {
        name: "Home",
        path: "/"
    },
    {
        name: "About us",
        path: "/about"
    },
    {
        name: "Courses",
        path: "/courses"
    },
    {
        name: "Contact us",
        path: "/contact"
    },
    {
        name: 'Global classroom',
        path: "/gclassroom",
        protected: true
    },
]

export const AppHeader = () => {

    const { user, isAuthenticated, logoutUser, token } = useAuth();

    const navigateTo = useNavigate();

    const [hAlert, setHAlert] = useState();
    const [open, setOpen] = useState(false);

    const toggleOpen = () => setOpen((o) => !o)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, [])


    return (
        <header className="app-header">
            {hAlert && (
                <AppAlert
                    caption={hAlert?.cap}
                    message={hAlert?.msg}
                    accept={'Ok'}
                    reject={'Cancel'}
                    onAccept={hAlert.onAccept}
                    onReject={() => setHAlert()}
                    closeAlert={() => setHAlert()}
                />
            )}
            <div className="logo-box">
                <img src="/sm-logo.png" alt="" width={80} />
            </div>
            <div className="app-name">
                <span className="top-name">Pathfinders</span>
                <span className="bottom-name">eSTEM hub</span>
            </div>
            <div className="nav-ctrl">
                <button className="tr-btn" onClick={toggleOpen}>
                    <FontAwesomeIcon icon={
                        open ? faClose : faBars
                    } />
                </button>
            </div>
            <div className={classNames("app-nav", { 'open-nav': open })}>
                <div className="nav-buttons">
                    {headerRoutes.map((route, indx) => (
                        <button
                            className="nav-button"
                            onClick={() => {
                                if (route.protected && !isAuthenticated) {
                                    setHAlert({
                                        cap: "Unauthorized! Please login",
                                        msg: "Please login to access this page",
                                        accept: "OK",
                                        reject: "Cancel",
                                        onAccept: () => navigateTo("/login"),
                                        onReject: () => setHAlert()
                                    });
                                    return;
                                }
                                navigateTo(route.path)
                            }}
                            key={indx}
                        >
                            {route.name}
                        </button>
                    ))}
                </div>
                <div className="auth-buttons">
                    {isAuthenticated === false ?
                        < div className="auth-on">
                            <button className="nav-button" onClick={() => navigateTo("/login")}>
                                Sign in
                            </button>
                            <button className="nav-button" onClick={() => navigateTo("/signup")}>
                                Create account
                            </button>
                        </div> :
                        <div className="auth-on">
                            <button className="nav-button" onClick={() => navigateTo("/aichat")}>
                                <img src="/svgs/chatgpt-6.svg" alt="chat-gpt" className="user-img" />
                            </button>
                            <button className={classNames("nav-button", "user-button")} onClick={() => navigateTo("/myaccount")}>
                                <span className="user-nm">{user?.firstname}{"  "}</span>
                                <img src={formatUrl(user?.avatar)} alt="" className="user-img" />
                            </button>
                            <button
                                className="nav-button"
                                onClick={() => {
                                    setHAlert({
                                        cap: "Sign out",
                                        msg: "Do you wish to sign out?",
                                        accept: "OK",
                                        reject: "Cancel",
                                        onAccept: () => logoutUser(token),
                                        onReject: () => setHAlert()
                                    });
                                }}
                            >
                                Sign out
                            </button>
                        </div>
                    }
                </div>
            </div>
        </header>
    )
}